<template>
    <div>
        <h3 class="green-text text-darken-1">
            {{ subtitle }}
        </h3>
        <span class="habiteo-body-2 grey-text">
            {{ description }}
        </span>
    </div>
</template>

<script>
    export default {
        name: 'StepHeader',
        props: {
            subtitle: {
                type: String,
                required: true
            },
            description: {
                type: String,
                required: true
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/StepHeader.vue